import React from "react";
import "./ConfirmationModal.css";

function ConfirmationModal({ message, open, setOpen, setConfirmed }) {
  return (
    <div
      className="overlay"
      style={{ display: open ? "flex" : "none" }}
      onClick={() => setOpen(false)}
    >
      <div className="container">
        <h3>{message ? message : ""}</h3>
        <div className="btnC">
          <div onClick={() => setConfirmed(true)}>Confirm</div>
          <div style={{ backgroundColor: "red" }}>Cancel</div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationModal;
